import { composeReducers } from 'common/util';

import {
    GET_STUDY_TESTAMENTS_FOR_INSTITUTION,
} from 'pages/delegationOfAuthority/actions/studyTestaments';

export function getStudyTestamentsForInstitution(state, action) {
    if (!action || action.type !== GET_STUDY_TESTAMENTS_FOR_INSTITUTION) {
        return state;
    }
    const doaTestaments = action.payload;
    
    return {
        ...state,
        doaTestaments,
    };
}

export default composeReducers(
    getStudyTestamentsForInstitution,
);